import { FC, useState } from 'react';
import { Card } from 'react-bootstrap';
import ListItem from 'components/logProcessing/ScrubbingRulesList/ListItem';
import { ScrubbingRule } from 'components/logProcessing/types';
import ConfirmDialog from 'components/common/Dialog/ConfirmDialog';

import 'components/logProcessing/ScrubbingRulesList/ScrubbingRulesList.scss';

type Props = {
  scrubbingRules: ScrubbingRule[];
  isWriteDisabled: boolean;
  onListItemDrag: (dragIndex: number, hoverIndex: number) => void;
  onListItemDrop: (id: number, position: number) => void;
  onRuleCopy: (id: number) => void;
  onRuleEdit: (id: number) => void;
  onRuleDelete: (id: number) => void;
};

type CurrentRule = {
  id: number;
  name: string;
};
/**
 * List of the Scrubbing Rules with Update, Delete, Edit callbacks and "DnD to order" capabilities
 */
const ScrubbingRulesList: FC<Props> = ({
  scrubbingRules,
  isWriteDisabled,
  onListItemDrag,
  onListItemDrop,
  onRuleCopy,
  onRuleEdit,
  onRuleDelete,
}: Props) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentRule, setCurrentRule] = useState<null | CurrentRule>({ id: 0, name: '' });

  function handleShowDeleteModal(id: number, name: string): void {
    setCurrentRule({ id, name });
    setShowDeleteModal(true);
  }

  function handleCloseDeleteModal(): void {
    setShowDeleteModal(false);
  }

  function handleDeleteSubmit(): void {
    if (currentRule) {
      onRuleDelete(currentRule.id);
    }
    handleCloseDeleteModal();
  }

  return (
    <div>
      <Card>
        {scrubbingRules.map(({ id, name }, index) => (
          <ListItem
            key={id}
            index={index}
            id={id as number}
            name={name}
            isWriteDisabled={isWriteDisabled}
            onDrag={onListItemDrag}
            onDrop={onListItemDrop}
            onCopy={onRuleCopy}
            onEdit={onRuleEdit}
            onDelete={handleShowDeleteModal}
          />
        ))}
      </Card>
      <ConfirmDialog
        title="Delete Filter"
        text={`Delete filter '${currentRule?.name}'?`}
        show={showDeleteModal}
        close={handleCloseDeleteModal}
        onSubmit={handleDeleteSubmit}
        textStyleClassName="FiltersList__Modal"
      />
    </div>
  );
};

export default ScrubbingRulesList;
